import { render, staticRenderFns } from "./BranceEdit.vue?vue&type=template&id=03cd562f&scoped=true"
import script from "./BranceEdit.vue?vue&type=script&lang=js"
export * from "./BranceEdit.vue?vue&type=script&lang=js"
import style0 from "./BranceEdit.vue?vue&type=style&index=0&id=03cd562f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd562f",
  null
  
)

export default component.exports